import { useQuery } from '@tanstack/react-query';
import type { ResourceApprovalDetailsResponse } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useResourceApprovalsDetails = (resourceApprovalUuid: string) => {
  const response = useQuery<ResourceApprovalDetailsResponse>({
    queryKey: [clientKeys.useResourceApprovalDetails, resourceApprovalUuid],
    enabled: !!resourceApprovalUuid,
    queryFn: async () =>
      await falconClient.get(
        `${baseUrl}/resource_approvals/${resourceApprovalUuid}/details`
      ),
  });

  return {
    resourceApprovalsDetails: response?.data?.resource_approval,
    ...response,
  };
};
